import React from "react";
import Embed from "semantic-ui-react/dist/commonjs/modules/Embed";

export const web_look = type => {
  return (
    <div className="web_look">
      <div className="pop">360°Web見学</div>
      <div className="collections">
        <div className="item">
          <div className="title">
            <span className="degrees" />
            屋内型トランクルーム
          </div>
          <a className="link360 inside" href="/web_okunai/" />
        </div>
        <div className="item">
          <div className="title">
            <span className="degrees" />
            屋外型トランクルーム
          </div>
          <a className="link360 outside" href="/web_okugai/" />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/detail/web_look.jsx